import React from 'react';
import { Card, CardSegment } from '../ui';
import ReactMarkdown from 'react-markdown';

const PrivateNote: React.FC<{ content: string }> = ({ content }) => {
  return (
    <Card className="silver bg-near-white tl f7 serif lh-copy mb2">
      <CardSegment className="pv4">
        <ReactMarkdown source={content} className="markdown-summary" />
      </CardSegment>
    </Card>
  );
};

export default PrivateNote;
